// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"96":"vendors","792":"main"}[chunkId] + "." + {"96":"d61656849dd18e6c88b2","792":"d446c9c9eedf0e32308a"}[chunkId] + ".css";
};